var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreTestShapes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 339,
    height: 206,
    viewBox: "0 0 339 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120.645 135.215H284.989C314.321 135.215 338.099 158.994 338.099 188.326C338.099 217.658 314.321 241.436 284.989 241.436H173.128C144.142 241.436 120.645 217.938 120.645 188.952V135.215Z",
    fill: "#007580"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M231.869 67.5341L284.979 67.5341L338.09 67.5341C338.09 96.8662 314.312 120.645 284.979 120.645C255.647 120.645 231.869 96.8662 231.869 67.5341Z",
    fill: "#FF7F50"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.869 53.1104L284.979 53.1104L338.09 53.1104C338.09 23.7783 314.312 2.07877e-06 284.979 4.64306e-06C255.647 7.20735e-06 231.869 23.7783 231.869 53.1104Z",
    fill: "#60C2A5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M-5.63921e-05 188.169L53.1103 188.169L106.221 188.169C106.221 217.501 82.4424 241.28 53.1103 241.28C23.7783 241.28 -5.89564e-05 217.501 -5.63921e-05 188.169Z",
    fill: "#60C2A5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.854 115.631L173.743 115.631L120.633 115.631C120.633 86.2988 144.411 62.5205 173.743 62.5205C203.075 62.5205 226.854 86.2988 226.854 115.631Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreTestShapes);
export default __webpack_public_path__ + "static/media/PreTestShapes.4bb2945a40733ee0ec690a3c5f622b47.svg";
export { ForwardRef as ReactComponent };